import { BottomModal } from "components/common/BottomModal/BottomModal";
import { BackIcon } from "components/common/Icons/BackIcon";
import { Translate } from "components/common/Translate/Translate";
import { EditSettings } from "../../EditSettings/EditSettings";
import { PreviewImage } from "./PreviewImage/PreviewImage";
import { usePreviewList } from "./usePreviewList";
import { MaxFileSizeIndicator } from "@/components/common/Uploader/MaxFileSizeIndicator/MaxFileSizeIndicator";

export const PreviewList = () => {
    const { images, handleSelect, handleDelete, close, isOpen, selectedImage, handleDownload, handleSettingsClick } =
        usePreviewList();

    return (
        <div className="lg:pb-4 h-full">
            {images.length === 0 && (
                <div className="flex flex-col items-center justify-center gap-4 dark:text-white">
                    <div
                        className="lg:hidden first-letter:capitalize text-center mt-16 text-xl px-4"
                        data-testid="preview-list-no-selelcted-image-text"
                    >
                        <Translate keyName="click-on-plus-icon-to-add-images" />
                    </div>
                    <div className="text-sm [&_a]:text-blue-500">
                        <MaxFileSizeIndicator />
                    </div>
                </div>
            )}
            <div className="grid grid-cols-2 items-start gap-4 px-4 bg-white dark:bg-darkSurface-100 mx-4 lg:mx-0 pt-4">
                {images.map((image, index) => (
                    <PreviewImage
                        key={image.id}
                        index={index}
                        handleSelect={handleSelect}
                        handleDownload={handleDownload}
                        handleDelete={handleDelete}
                        image={image}
                        isSelected={image.id === selectedImage?.id}
                        handleSettingsClick={handleSettingsClick}
                    />
                ))}
                <div className="lg:hidden">
                    <BottomModal
                        isOpen={isOpen}
                        lockBackground={false}
                        onClose={close}
                        initialHeight="100vh"
                        parentClassNames="lg:hidden"
                        titleBar={
                            <div className="relative w-full flex items-center gap-3 px-4 pt-2 text-black dark:text-white">
                                <div className="" onClick={close}>
                                    <BackIcon />
                                </div>
                                <div className="text-xl font-semibold capitalize">
                                    <Translate keyName="adjust-quality" />
                                </div>
                            </div>
                        }
                        disableDrag={true}
                    >
                        <div className="w-full h-full pt-4 text-black">
                            <EditSettings />
                        </div>
                    </BottomModal>
                </div>
            </div>
        </div>
    );
};
